import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import HelpButton from "../../HelpContent/HelpButton";
import MyIcon from "../MyIcon";
import LdapIcon from "../../../assets/icons/ldap-01.svg2";

export default function LdapCredentialsForm() {
  return (
    <div className=" align-items-center rounded-3 py-4 mt-4 ps-4 pe-5 bg-purple-gradient-darker-reverse m-3 ">
      <div className="d-flex">
        <div>
          <MyIcon Icon={LdapIcon} width={30} className="me-2" />
        </div>
        <div>
          <div className="fw-bold">LDAP Credentials</div>
          <div className="small opacity-50">
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
          </div>
        </div>
      </div>
      <div>
        <Form>
          <Form.Group as={Row} className="mb-3 mt-3" controlId="ldapEndpointUrl">
            <Form.Label column sm="4" className="fw-bold">
              Endpoint URL:
              <HelpButton />
            </Form.Label>
            <Col sm="8">
              <Form.Control type="text" />
            </Col>
          </Form.Group>
          <hr className="text-secondary" />

          <Form.Group as={Row} className="mb-3" controlId="ldapUsername">
            <Form.Label column sm="4" className="fw-bold">
              Username:
              <HelpButton />
            </Form.Label>
            <Col sm="8">
              <Form.Control type="text" />
            </Col>
          </Form.Group>
          <hr className="text-secondary" />

          <Form.Group as={Row} className="mb-3" controlId="ldapPassword">
            <Form.Label column sm="4" className="fw-bold">
              Password:
              <HelpButton />
            </Form.Label>
            <Col sm="8">
              <Form.Control type="password" />
            </Col>
          </Form.Group>
          <hr className="text-secondary" />

          <Form.Group as={Row} className="mb-3" controlId="ldapPostNumber">
            <Form.Label column sm="4" className="fw-bold">
              Port Number:
              <HelpButton />
            </Form.Label>
            <Col sm="4">
              <Form.Control type="number" />
            </Col>
          </Form.Group>
          <hr className="text-secondary" />
          <Form.Group as={Row} className="mb-3" controlId="ldapUseSsl">
            <Form.Label column sm="4" className="fw-bold">
              Use SSL?
              <HelpButton />
            </Form.Label>
            <Col sm="8">
              <Form.Check // prettier-ignore
                type="switch"
                id="sslSwitch"
              />
            </Col>
          </Form.Group>
        </Form>
        <div className="d-flex justify-content-end">
          <Button
            type="submit"
            className="btn btn-colored-reverse rounded-pill fw-bold px-4 "
          >
            CONNECT
          </Button>
        </div>
      </div>
    </div>
  );
}
